var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditMemberIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2321 32.6022H1.53979V28.7561C1.56021 26.8017 2.07563 24.8844 3.03793 23.1832C4.00023 21.4821 5.378 20.0525 7.04255 19.0282C8.7071 18.0039 10.6041 17.4181 12.5564 17.3257C14.5087 17.2333 16.4526 17.6372 18.2065 18.4997M18.8474 7.60224C18.8474 10.7885 16.2645 13.3715 13.0782 13.3715C9.89195 13.3715 7.30897 10.7885 7.30897 7.60224C7.30897 4.41598 9.89195 1.83301 13.0782 1.83301C16.2645 1.83301 18.8474 4.41598 18.8474 7.60224ZM34.8731 22.3458L22.7962 34.4228L17.3347 35.1663L18.1039 29.7048L30.1552 17.6279L34.8731 22.3458Z",
    stroke: "#0E9349",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditMemberIcon);
export default __webpack_public_path__ + "static/media/editMemberIcon.0b3677291a253f89ca22ae6633fb6eb0.svg";
export { ForwardRef as ReactComponent };